module.exports = __webpack_public_path__ + "pc/img/swiper_bg_05.88013e07.jpg";